import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import accountingImg1 from "../assets/images/accountingimg1.jpg";

const COURSES = [
  {
    title: "Business Courses",
    image: "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbusiness-bpo-virtual-assistance.bd8b9c2e.webp&w=1920&q=75",
    description: "Practical business skills in planning, marketing, finance, and operations for entrepreneurs.",
    points: ["Aspiring Entrepreneurs", "Startup Founders", "Small Business Owners", "MBA Students", "Freelancers and Consultants"],
    paymentLink: "https://shop.bkash.com/jk-associatesrm53807/paymentlink/default-payment",
  },
  {
    title: "Accounting Training",
    image: accountingImg1,
    description: "Professional Accounting Certificate Courses for working professionals and finance enthusiasts.",
    points: ["Fresh Graduates", "Small Business Owners", "Entrepreneurs", "Job Seekers in the Finance Sector", "Mid-level Accounting Professionals"],
    paymentLink: "https://shop.bkash.com/jk-associatesrm53807/paymentlink/default-payment",
  },
  {
    title: "Taxation Courses",
    image: "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbusiness-bpo-accounting-service.8bc34464.jpg&w=1920&q=75",
    description: "Master principles of income tax, VAT, and corporate tax for professionals and business owners.",
    points: ["Accounting Professionals", "Corporate Finance Officers", "Tax Consultants", "Small Business Owners", "Audit Professionals"],
    paymentLink: "https://shop.bkash.com/jk-associatesrm53807/paymentlink/default-payment",
  },
  {
    title: "Management Courses",
    image: "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fsocial-media-marketing.625a5c6a.jpg&w=1920&q=75",
    description: "Leadership, team management, and decision-making skills for professionals advancing in management.",
    points: ["New Managers", "Team Leaders", "Supervisors", "Project Managers", "Department Heads"],
    paymentLink: "https://shop.bkash.com/jk-associatesrm53807/paymentlink/default-payment",
  },
];


export default function IndustryShowcase2() {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleDropdown = (index) => setActiveIndex(prev => (prev === index ? null : index));

  // Redirect to admission form after payment
  const redirectUrl = `${window.location.origin}/training#admission-form`;

  const handleEnrollClick = (link) => {
    // Open payment in same tab
    window.location.href = `${link}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="container py-5"
    >
      <div className="text-center mb-5">
        <h1 style={{ fontSize: "36px", fontWeight: "700", color: "#0d6efd" }}>
          Grow Your Career with Professional Training!
        </h1>
        <p style={{ fontSize: "18px", color: "#555" }}>
          Our practical professional courses help you gain skills and get hired.
        </p>
      </div>

      <div style={{ display: "flex", gap: "20px", overflowX: "auto", paddingBottom: "20px" }}>
        {COURSES.map((course, idx) => {
          const isActive = activeIndex === idx;
          return (
            <div key={idx} style={{ flex: "0 0 300px" }}>
              <motion.div
                whileHover={{ scale: 1.02 }}
                className="card p-0"
                style={{
                  borderRadius: "12px",
                  cursor: "pointer",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                  backgroundColor: "#e7f1ff",
                  display: "flex",
                  flexDirection: "column",
                }}
                onClick={() => toggleDropdown(idx)}
              >
                <div style={{ width: "100%", height: "150px", borderTopLeftRadius: "12px", borderTopRightRadius: "12px", overflow: "hidden" }}>
                  <img src={course.image} alt={course.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>

                <div className="p-3 d-flex justify-content-between align-items-center" style={{ minHeight: "64px", padding: "16px" }}>
                  <h5 style={{ color: "#0d6efd", fontWeight: "600", margin: 0, fontSize: "16px", lineHeight: "1.3" }}>
                    {course.title}
                  </h5>
                  <motion.div animate={{ rotate: isActive ? 180 : 0 }} transition={{ duration: 0.3 }} style={{
                    width: "32px",
                    height: "32px",
                    background: "#fff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                  }}>
                    <ChevronDown size={16} color="#0d6efd" />
                  </motion.div>
                </div>

                {isActive && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="p-3"
                    style={{
                      borderTop: "1px solid #0d6efd",
                      borderRadius: "0 0 12px 12px",
                      backgroundColor: "#0d6efd",
                      color: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      padding: "20px",
                    }}
                  >
                    <p>{course.description}</p>
                    <ul style={{ paddingLeft: "20px", marginBottom: "10px" }}>
                      {course.points.map((point, i) => (
                        <li key={i}>• {point}</li>
                      ))}
                    </ul>

                    {/* Payment Button */}
                    <button
                      onClick={() => handleEnrollClick(course.paymentLink)}
                      style={{
                        display: "inline-block",
                        padding: "10px 20px",
                        borderRadius: "6px",
                        backgroundColor: "#ffc107",
                        color: "#0d6efd",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                        alignSelf: "start",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd633")}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffc107")}
                    >
                      Enroll Course
                    </button>
                  </motion.div>
                )}
              </motion.div>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
